import Button from '@berlitz/button'
import includes from 'lodash/includes'
import Link from 'next/link'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { nonLessons } from '@utils/lesson-type'
import { Anchor } from './style'

const nlt = nonLessons.map((lesson) => lesson.toLowerCase())

export { TextLabel } from './style'
export interface Prop {
  type: string
  url: string
}

const LessonRegButton: React.FC<Prop> = ({ type, url }) => {
  const showButton = !includes(nlt, (type || '').toLowerCase())

  return (
    <>
      {showButton && (
        <Link href={url} legacyBehavior>
          <Anchor>
            <Button outline small>
              <FormattedMessage id="Lesson reg" />
            </Button>
          </Anchor>
        </Link>
      )}
    </>
  )
}

export default LessonRegButton
